function waitForElement(selector, callback, timeout = 5000) {
  const startTime = Date.now();
  const interval = setInterval(() => {
    const el = document.querySelector(selector);
    if (el) {
      clearInterval(interval);
      callback(el);
    } else if (Date.now() - startTime > timeout) {
      clearInterval(interval);
      console.warn(`Element ${selector} not found within ${timeout}ms`);
    }
  }, 100);
}

document.addEventListener('DOMContentLoaded', function () {
  // Add to Cart functionality with check for .tee-required-message
  waitForElement('#teeAtcButton', function (teeAtcButton) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    teeAtcButton.addEventListener('click', async (e) => {
      e.preventDefault();

      // Check if any .tee-required-message is visible
      const requiredMessages = document.querySelectorAll('.tee-required-message');
      const hasErrors = Array.from(requiredMessages).some(el => el.offsetParent !== null); 
      // Check if element is actually visible (not display: none)

      if (hasErrors) {
        console.warn('Product not added. Required fields are missing.');
        return; // 🔥 STOP — do not proceed
      }

      // Proceed to add to cart
      const variantId = document.querySelector('input[name="id"]')?.value;
      if (!variantId) {
        console.warn('Variant ID not found. Product not added.');
        return;
      }

      // try {
      //   await fetch('/cart/add.js', {
      //     method: 'POST',
      //     headers: { 'Content-Type': 'application/json' },
      //     body: JSON.stringify({ id: variantId, quantity: 1 }),
      //   });

      //   const sectionsResponse = await fetch('/?sections=cart-drawer');
      //   const sectionsJson = await sectionsResponse.json();

      //   const newHtml = sectionsJson['cart-drawer'];
      //   const parser = new DOMParser();
      //   const doc = parser.parseFromString(newHtml, 'text/html');
      //   const newDrawer = doc.querySelector('#CartDrawer');
      //   const currentDrawer = document.querySelector('#CartDrawer');

      //   if (newDrawer && currentDrawer) {
      //     currentDrawer.innerHTML = newDrawer.innerHTML;
      //   }

      //   cartDrawer.classList.remove('is-empty');
      //   cartDrawer.open();

      //   ckResetCountdown();

      // } catch (error) {
      //   console.error('Failed to add product and update cart:', error);
      // }
    });
  });

  // Price savings calculation (percentage)
  waitForElement('.tee-price--compare', () => {
    const comparePriceEl = document.querySelector('.tee-price--compare');
    const currentPriceEl = document.querySelector('.tee-price--current');
    const savingEl = document.querySelector('.tee-price--saving .price');

    if (!comparePriceEl || !currentPriceEl || !savingEl) return;

    const comparePrice = parseFloat(comparePriceEl.textContent.replace(/[^0-9.]/g, ''));
    const currentPrice = parseFloat(currentPriceEl.textContent.replace(/[^0-9.]/g, ''));

    if (isNaN(comparePrice) || isNaN(currentPrice) || comparePrice <= currentPrice) {
      savingEl.closest('.tee-price--saving').style.display = 'none';
      return;
    }

    const savingPercent = ((comparePrice - currentPrice) / comparePrice) * 100;
    const roundedPercent = Math.round(savingPercent);

    if (roundedPercent > 0) {
      savingEl.textContent = `${roundedPercent}%`;
      savingEl.closest('.tee-price--saving').style.display = 'block';
    } else {
      savingEl.closest('.tee-price--saving').style.display = 'none';
    }
  });
});
